/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FormatProblemRequest,
  FormatProblemResponse,
  FormatStatementRequest,
  FormatStatementResponse,
  HTTPValidationError,
} from '../models/index';
import {
    FormatProblemRequestFromJSON,
    FormatProblemRequestToJSON,
    FormatProblemResponseFromJSON,
    FormatProblemResponseToJSON,
    FormatStatementRequestFromJSON,
    FormatStatementRequestToJSON,
    FormatStatementResponseFromJSON,
    FormatStatementResponseToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/index';

export interface FormatProblemOperationRequest {
    formatProblemRequest: FormatProblemRequest;
}

export interface FormatStatementOperationRequest {
    formatStatementRequest: FormatStatementRequest;
    xOrganizationID?: string | null;
}

/**
 * 
 */
export class AiApi extends runtime.BaseAPI {

    /**
     * Format one problem draft from a competition PDF import into statement HTML.  Image markers in the text are repaired and replaced with the given image URLs; the warnings list each repair. Requires the competition organizer role or superadmin. Returns 422 for an empty or missing marked_text (schema validation), 400 for marked_text that is only whitespace, 502 when the AI call fails and 503 when the AI deployment is unavailable.
     * Format Problem
     */
    async formatProblemRaw(requestParameters: FormatProblemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormatProblemResponse>> {
        if (requestParameters['formatProblemRequest'] == null) {
            throw new runtime.RequiredError(
                'formatProblemRequest',
                'Required parameter "formatProblemRequest" was null or undefined when calling formatProblem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ai/format-problem`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormatProblemRequestToJSON(requestParameters['formatProblemRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormatProblemResponseFromJSON(jsonValue));
    }

    /**
     * Format one problem draft from a competition PDF import into statement HTML.  Image markers in the text are repaired and replaced with the given image URLs; the warnings list each repair. Requires the competition organizer role or superadmin. Returns 422 for an empty or missing marked_text (schema validation), 400 for marked_text that is only whitespace, 502 when the AI call fails and 503 when the AI deployment is unavailable.
     * Format Problem
     */
    async formatProblem(requestParameters: FormatProblemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormatProblemResponse> {
        const response = await this.formatProblemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Format a raw problem statement text into well-structured HTML.  Requires content creator or organization administrator role. Returns 400 for empty text, 502 when the AI call fails and 503 when the AI deployment is unavailable.
     * Format Statement
     */
    async formatStatementRaw(requestParameters: FormatStatementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormatStatementResponse>> {
        if (requestParameters['formatStatementRequest'] == null) {
            throw new runtime.RequiredError(
                'formatStatementRequest',
                'Required parameter "formatStatementRequest" was null or undefined when calling formatStatement().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ai/format-statement`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FormatStatementRequestToJSON(requestParameters['formatStatementRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormatStatementResponseFromJSON(jsonValue));
    }

    /**
     * Format a raw problem statement text into well-structured HTML.  Requires content creator or organization administrator role. Returns 400 for empty text, 502 when the AI call fails and 503 when the AI deployment is unavailable.
     * Format Statement
     */
    async formatStatement(requestParameters: FormatStatementOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormatStatementResponse> {
        const response = await this.formatStatementRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
